import Vue from 'vue'
import { vfmPlugin } from 'vue-final-modal'

Vue.use(vfmPlugin)
const els = document.querySelectorAll("[id^='form-trigger--']")
if (els != null) {
  els.forEach((el) => {
    // eslint-disable-next-line no-unused-vars
    const app = new Vue({
      el: el,
      data: () => ({
        showModal: false,
      }),
      delimiters: ['[[', ']]'],
      watch: {
        showModal: {
          handler: function (val) {
            if (this.showModal) {
              if (typeof window.Formie.initForms !== 'undefined') {
                this.$nextTick(() => {
                  window.Formie.initForms()
                })
              }
              document.documentElement.classList.add('modal-open','is-clipped')
              //add a data attribute tot he body to track the modal
              document.body.setAttribute('data-lenis-prevent', 'true')
            } else {
              document.documentElement.classList.remove('modal-open','is-clipped')

            }
          }
        }
      }
    })
    app.$mount(el)
  })
}
